import base from './base';

export default {
  ...base,
  common: {
    ...base.common,
    en: 'EN',
    sp: 'SP'
  },
  footer: {
    address: {
      one: 'Oficina corporativa',
      two: 'Oficina',
      three: 'Online',
      onedetails: 'Houston, TX',
      twodetails: '844-636-1360',
      threedetails: 'info@gorillasafety.com'
    },
    patent: 'Patente pendiente',
    copyright: '2025 Clear Path ELD Todos los derechos reservados',
    PrivacyLegal: 'Privacidad y legal'
  }
};
